import { render, staticRenderFns } from "./TreeSelectBaseComponent.vue?vue&type=template&id=0bbf576c&"
import script from "./TreeSelectBaseComponent.vue?vue&type=script&lang=js&"
export * from "./TreeSelectBaseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports